import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import Header from "./Header";
import ConsultationFooter from "./ConsultationFooter";

import { CloseButton } from "react-bootstrap";
import AddRemove from "./AddRemove";
import { getMedical } from "../api";

const MedicalInfo = ({
  medical,
  comment,
  files,
  setStep,
  setMedical,
  setComment,
  setFiles,
}) => {
  const [errors, setErrors] = useState({});

  const [medicalList, setMedicalList] = useState([]);

  console.log("files:", files, files?.length, errors);
  const validate = () => {
    let errors = {};

    if (!medical || medical === "Select Medical")
      errors.medical = "Medical is required";
    if (!comment) errors.comment = "Comment is required";
    if (
      files === "null" ||
      files === null ||
      files?.length <= 0 ||
      !files.every((file) => file.name)
    )
      errors.files = "Medical File is required";
    // if (!files) errors.files = "Files are required";

    setErrors(errors);
    return Object.keys(errors).length;
  };
  useEffect(() => {
    (async () => {
      const data = await getMedical();
      setMedicalList(data?.data?.data);
    })();
  }, []);
  const onFilesChange = (e) => {
    setFiles(e.target.files);
  };

  const nextStep = () => {
    const valid = validate();
    if (valid > 0) return;

    setStep(2);
  };

  return (
    <div className="patientinfo">
      <Logo />
      <div className="card wizard-card">
        <div className="centre_content">
          <Header active={1} />
          <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
            <div className="uploadingdata">
              <div
                className="upload_attech"
                backgroundColor={{ backgroundColor: "rgba(0,0,0,.1)" }}
              >
                Upload Attachments
              </div>
              <div className="uploadpara">
                Upload clinically relevant images, video, labs, pathology
                reports and other medical records
                <span className="smallword">(png, jpg, pdf format only)</span>
              </div>
              <AddRemove files={files} setFiles={setFiles} />
              {errors?.files && (
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    margin: "-10px 0px 0px 2px",
                  }}
                  className="medical-files-errors"
                >
                  {errors?.files}
                </p>
              )}
            </div>

            <select
              className="form-select-medical"
              aria-label="Default select example"
              onChange={(e) => {
                setMedical(e.target.value);
              }}
              value={medical}
              required
              defaultValue={"Select Medical"}
              autoComplete="off"
            >
              <option disabled hidden value={"Select Medical"}>
                Select Medical Issue
              </option>
              {medicalList.length > 0 &&
                medicalList.map((med) => (
                  <option key={med} value={med}>
                    {med}
                  </option>
                ))}
            </select>
            {medical == "Select Medical" && errors?.medical && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  margin: "2px 0px 0px 2px",
                }}
              >
                {errors?.medical}
              </p>
            )}
            <div className="msginput-medical">
              <textarea
                className="loding_area"
                placeholder="Comment"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                required
                autoComplete="off"
              />
              {comment == "Select an Option" ||
                (errors?.comment && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      margin: "-3px 0px 0px 2px",
                    }}
                  >
                    {errors?.comment}
                  </p>
                ))}
            </div>
          </div>
        </div>
        <div className="wizard-footer height-wizard">
          <div className="pull_left" style={{ paddingLeft: "10px" }}>
            <button
              className="llll"
              style={{ backgroundColor: "#999" }}
              onClick={() => {
                setStep(0);
              }}
            >
              PREVIOUS
            </button>
          </div>
          <div className="pull_right" style={{ paddingRight: "10px" }}>
            <button className="KKK" onClick={nextStep}>
              NEXT
            </button>
          </div>
        </div>
      </div>
      <ConsultationFooter />
    </div>
  );
};

export default MedicalInfo;
